import api from '@/services/api'

export default {
  createDelivery(delivery) {
    return api.post(`delivery/`, delivery)
        .then(response => response.data)
  },
  editDelivery(delivery) {
    return api.put(`delivery/${delivery.id}/`, delivery)
        .then(response => response.data)
  }
}